export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9997_EVALUATION_DETAILS': 'Evaluation Details',
    '_1502_INDIVIDUAL': 'Individual',
    '_9998_EVALUATION_NAME': 'Evaluation Name',
    '_9999_EVENT_DATE': 'Event Date',
    '_10000_EVENT_TIME': 'Event Time',
    '_10001_EVALUATION_DATE': 'Evaluation Date',
    '_10002_TOTAL_SCORE': 'Total Score',
    '_10003_TOTAL_': 'Total:',
    '_10019_SUMMARY_COMMENTS': 'Summary Comments',
    '_10005_SAVE_AS_DRAFT': 'Save as draft',
    '_9415_PUBLISH': 'Publish',
    '_10006_THE_SCORE_HAS_BEEN_AFFECTED_BY_AN_AUTO_FAIL_EVENT': 'The score has been affected by an auto-fail event',
    '_10007_THIS_QUESTION_HAS_TRIGGERED_AN_AUTO_FAIL_EVENT': 'This question has triggered an auto-fail event',
    '_10008_EXISTING_DRAFT_LOADED': 'Existing draft loaded',
    '_10009_DRAFT_SAVED': 'Draft Saved',
    '_9479_CONFIRMATION': 'Confirmation',
    '_10010_CONFIRM_YOU_WOULD_LIKE_TO_PUBLISH_THIS_EVALUATION': 'Confirm you would like to publish this evaluation',
    '_9425_OK': 'OK',
    '_121_CANCEL': 'Cancel',
    '_10020_SAVE': 'Save',
    '_48_MANAGER': 'Manager',
    '_10030_EVALUATOR': 'Evaluator',
    '_11076_EXPAND_ALL_GROUPS': 'Expand All Groups',
    '_11077_COLLAPSE_ALL_GROUPS': 'Collapse All Groups',
    '_9715_QUEUE_': 'Queue:',
    '_842_N_A': 'N/A',
    '_11078_CONTACT_LENGTH': 'Contact Length',
    '_11079_MINUTES': 'minutes'
};
